"use strict";

var _LoggedInUserScreen, _UnAuthedUserScreen;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@autoguru/auth';
import { AsyncBoundary } from '@autoguru/suspense';
import { PageLoading } from '@autoguru/components';
import { ContainedLayout } from '@autoguru/layout';
import { lazy } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const LoggedInUserScreen = /*#__PURE__*/lazy(async () => import('../../features/loged-in-user-screen/LoggedInUserScreen'));
const UnAuthedUserScreen = /*#__PURE__*/lazy(async () => import('../../features/unauthed-in-user-screen/UnAuthedUserScreen'));
const Landing = () => {
  const $ = _c(3);
  if ($[0] !== "69bffacde9fcf97d1a98c6a465ef7b8687f2fdd6c78159992d6ec1ab9889a4ee") {
    for (let $i = 0; $i < 3; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "69bffacde9fcf97d1a98c6a465ef7b8687f2fdd6c78159992d6ec1ab9889a4ee";
  }
  const {
    isAuthenticated
  } = useAuth();
  let t0;
  if ($[1] !== isAuthenticated) {
    t0 = /*#__PURE__*/_jsx(ContainedLayout, {
      children: /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: PageLoading,
        children: isAuthenticated ? _LoggedInUserScreen || (_LoggedInUserScreen = /*#__PURE__*/_jsx(LoggedInUserScreen, {})) : _UnAuthedUserScreen || (_UnAuthedUserScreen = /*#__PURE__*/_jsx(UnAuthedUserScreen, {}))
      })
    });
    $[1] = isAuthenticated;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Landing;